// Group audit (owner, 5 Nov 2026): the other companies audited together with the job's company — one line under the
// page heading on the IA job page and the auditor worksheet. Nothing shows for a single-company audit.
// The list lives on the internal audit record (ia_group_companies → client_ia_cycles), so every yearly job picks it up.
import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

// The group companies of an internal audit record, in their saved order: [{ client_id, name, uen }].
export async function loadIAGroup(cycleId) {
  if (!cycleId) return []
  const { data, error } = await supabase.from('ia_group_companies').select('client_id, sort_order, clients(name, uen)')
    .eq('cycle_id', cycleId).is('removed_at', null).order('sort_order')
  if (error) return []
  return (data || []).map(l => ({ client_id: l.client_id, name: l.clients?.name || '—', uen: l.clients?.uen || '' }))
}

export const groupCompanyText = g => `${g.name}${g.uen ? ` (${g.uen})` : ''}`

export default function IAGroupLine({ cycleId, style }) {
  const [group, setGroup] = useState([])
  useEffect(() => {
    let live = true
    loadIAGroup(cycleId).then(g => { if (live) setGroup(g) })
    return () => { live = false }
  }, [cycleId])
  if (!group.length) return null
  return <div style={{ fontSize: 13, color: 'var(--text2)', ...style }}>Group audit: {group.map(groupCompanyText).join(', ')}</div>
}
